import React, { useState } from 'react'
import { setMerchantAllowedCurrencies } from '../api'
import { useAuth } from '../auth'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

/**
 * SetMerchantAllowedCurrencies a component that will set a merchants allowed territories
 */
const SetMerchantAllowedCurrencies = ({ merchant, onSuccess, onCancel }) => {
  const { token } = useAuth()
  const [currencies, setCurrencies] = useState(merchant?.allowed_currencies || [])
  const [failed, setFailed] = useState()
  const [saving, setSaving] = useState(false)

  const onSetCurrencies = async () => {
    setFailed(null)
    setSaving(true)
    try {
      await setMerchantAllowedCurrencies(token, {
        merchant_id: merchant.id,
        currencies: currencies,
      })
      setSaving(false)
      onSuccess()
    } catch (e) {
      setSaving(false)
      setFailed(e)
    }
  }

  return (
    <div className='link-parent'>
      <h3>Set the allowed currencies for {merchant.registered_name || '(un-named merchant)'}</h3>
      <div className='content'>
        <p>
          <input type='text' value={currencies} onChange={(e) => setCurrencies(e.target.value)} />
        </p>

        {saving && <p className='loading'>Updating...</p>}
        {failed && (
          <p className='error'>
            {failed ? (
              <span>{failed}</span>
            ) : (
              <span>
                Something went wrong - please try again, or{' '}
                <Link to='/support'>contact support</Link>
              </span>
            )}
          </p>
        )}
      </div>
      <p className='warning'>
        <em>
          <strong>WARNING:</strong> This will set all the currencies the merchant may operate in
        </em>
      </p>
      <footer className='actions'>
        <button
          onClick={onSetCurrencies}
          disabled={
            false /* removing for now so we can unset !currencies || currencies.length === 0*/
          }
        >
          Set currencies
        </button>
        <button onClick={onCancel}>Cancel</button>
      </footer>
    </div>
  )
}

SetMerchantAllowedCurrencies.propTypes = {
  // The merchant object
  merchant: PropTypes.object.isRequired,
  // Success callback handler
  onSuccess: PropTypes.func,
  // Cancel callback handler
  onCancel: PropTypes.func,
}

export default SetMerchantAllowedCurrencies
